import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable, of } from "rxjs";
import { timeout, map } from "rxjs/operators";

const mainUrl = environment.url;

@Injectable({
  providedIn: "root",
})
export class AuthService {
  accessToken: string;

  constructor(private http: HttpClient) {
    this.accessToken = localStorage.getItem("token");
  }

  isAuthenticated() {
    const token: string = localStorage.getItem("token");
    return of(token);
  }

  login(form): Promise<any> {
    return this.http
      .post(mainUrl + "auth", form)
      .pipe(
        timeout(30000),
        map((res) => res)
      )
      .toPromise()
      .then(
        (data: any) => {
          return Promise.resolve(data);
        },
        (_error) => {
          return Promise.reject(_error);
        }
      );
  }

  newOTP(form): Promise<any> {
    return this.http
      .post(mainUrl + "otp/re-send", form)
      .pipe(
        timeout(30000),
        map((res) => res)
      )
      .toPromise()
      .then(
        (data: any) => {
          return Promise.resolve(data);
        },
        (_error) => {
          return Promise.reject(_error);
        }
      );
  }

  getMyIp(): Promise<any> {
    return this.http
      .get("https://api.ipify.org?format=json")
      .pipe(
        timeout(30000),
        map((res) => res)
      )
      .toPromise()
      .then(
        (data: any) => {
          return Promise.resolve(data);
        },
        (_error) => {
          return Promise.reject(_error);
        }
      );
  }

  loginOTP(form): Promise<any> {
    return this.http
      .post(mainUrl + "auth", form)
      .pipe(
        timeout(30000),
        map((res) => res)
      )
      .toPromise()
      .then(
        (data: any) => {
          return Promise.resolve(data);
        },
        (_error) => {
          return Promise.reject(_error);
        }
      );
  }

  setAccessToken(data) {
    const token = "Bearer " + data;
    this.accessToken = token;
    localStorage.setItem("token", token);
  }

  profile() {
    return this.http.get(mainUrl + "profile").pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  rememberPassword(email): Observable<any> {
    return this.http.post(mainUrl + "remember", email).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  updatePassword(data): Observable<any> {
    return this.http.put(mainUrl + "user/password", data).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  changePassword(data, token): Observable<any> {
    return this.http.put(mainUrl + "remember/" + token, data).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  downloadPdf(token): Observable<any> {
    return this.http.get(mainUrl + "remember/file/" + token).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getHeader() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: this.accessToken,
    });

    return headers;
  }
}
